import { faAngleDown, faAngleUp } from '@fortawesome/pro-solid-svg-icons';
var getAccordionIcon = function (toggle) {
    return (toggle ? faAngleUp : faAngleDown);
};
export default getAccordionIcon;
//# sourceMappingURL=getAccordionIcon.js.map